package uz.ferro.shop.pages.admin.debt

import uz.ferro.shop.api.suspendGet
import uz.ferro.shop.api.suspendPost
import uz.ferro.shop.pages.admin.debt.model.CrmSalesPoint
import uz.ferro.shop.pages.admin.debt.model.CustomerDebt
import uz.ferro.shop.pages.admin.debt.model.DebtFilter

object DebtManager {

    suspend fun getDebtList(filter: DebtFilter): List<CustomerDebt> {
        return suspendPost(
            path = "admin/debt/list/grouped",
            body = filter
        )
    }

    suspend fun getSalesPoints(): List<CrmSalesPoint> {
        return suspendGet("admin/debt/sales-points")
    }
}